import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ProductsService } from '../../../../../services';
import { ProductImageApi, LoopBackConfig, LoopBackAuth } from '../../../../../../assets/js/lb-sdk';
import { UploadInput, UploadOutput, UploaderOptions } from 'ngx-uploader';
import { STORAGE_LOCATIONS } from '../../../../../enums';
import { finalize } from 'rxjs/operators';
import { formatEvent } from '@app/helpers/upload-input-formatter'  

interface ProductImageForm {
  id?: string,
  product: { id: string, name: string, planTypeCode: string },
  productType: { id: string, name: string, products: any },
  description: string,
  image: any
}

@Component({
  selector: 'app-product-image-form',
  templateUrl: './product-image-form.component.html',
  styleUrls: ['./product-image-form.component.css']
})
export class ProductImageFormComponent implements OnInit {
  data: ProductImageForm;
  loading: boolean = false;
  error: string;
  file;
  uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
  options: UploaderOptions = {
    concurrency: 1,
    allowedContentTypes: ['image/jpeg', 'image/png']
  };

  constructor(
    public modal: BsModalRef,
    public productService: ProductsService,
    private productImageApi: ProductImageApi,
    private loopBackAuth: LoopBackAuth
  ) { }

  ngOnInit() {
    this.data = this.data || {
      product: undefined,
      productType: undefined,
      description: undefined,
      image: undefined
    };
  }

  onUploadOutput(output: UploadOutput) {
    switch (output.type) {
      case 'addedToQueue':
        if (typeof output.file !== 'undefined') {
          this.error = undefined;
          this.file = output.file;
        }
        break;
      case 'start':
        this.loading = true;
        break;
      case 'rejected':
        this.data.image = undefined;
        this.file = undefined;
        this.error = "File Rejected";
        break;
      case 'done':
        setTimeout(() => {
          this.loading = false;
          if (output.file && output.file.responseStatus === 200) {
            this.modal.content.result = 'success';
            this.modal.hide();
          } else {
            this.data.image = undefined;
            this.file = undefined;
            this.error = "File Upload failed";
          }
        }, 1000);
        break
      default:
        break;
    }
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(form) {
    if (form.valid) {
      const {
        id,
        product,
        productType,
        description,
        image
      } = this.data;
      if (image) {

        const path = LoopBackConfig.getPath() + '/api/AmazonS3/' + STORAGE_LOCATIONS.PRODUCT_IMAGES + '/upload';
        if (path && path !== '') {
          const event = formatEvent('uploadAll',path,
            this.loopBackAuth.getToken() && this.loopBackAuth.getToken().id || '', 
            {
              productType: productType.name,
              planType: product.planTypeCode,
              description
            }
            )
            
          this.uploadInput.emit(event);
        }
      } else {
        this.productImageApi
          .patchAttributes(id, {
            productType: productType.name,
            planType: product.planTypeCode,
            description
          })
          .pipe(finalize(() => {
            // DO SOMETHING AFTER UPDATE
          }))
          .subscribe(() => {
            this.modal.content.result = 'success';
            this.modal.hide();
          }, error => {
            this.error = error.message || 'Product Image update failed';
          })
      }
    }
  }
}
